module.exports = __webpack_public_path__ + "static/media/Raiders.5d5fabca.jpg";